import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
// import { API_URL } from '../constants'

// export const TEST_BASE_URL = 'http://127.0.0.1:6006'

const config: AxiosRequestConfig = {
  timeout: 60000,
  headers: { 'Content-Type': 'application/json' },
}

const axiosInstance = axios.create(config)

  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
      // Extract country from response headers (fallback to unknown string if missing)
      const country = response.headers['x-country'] || 'unknown';
      // Set localStorage flag for Canada detection (used elsewhere in app, e.g., for locale/region logic)
      localStorage.setItem('isUSD', country === 'ca' ? 'true' : 'false');

      return response
    },
    (error) => {
      return Promise.reject(error)
    }
  )


export { axiosInstance }
